(function () {
  const faqHandles = document.querySelectorAll(".hp-faq--faq-group-handle");
  faqHandles.forEach((handle) => {
    handle.addEventListener("click", handleClick);
  });

  const faqs = document.querySelectorAll(".hp-faq--question");
  faqs.forEach((question) => {
    question.addEventListener("click", handleClick);
  });

  function handleClick() {
    const parent = this.parentElement;
    const answer = this.nextElementSibling;
    const style = window.getComputedStyle(answer);
    const isOpened = parent.classList.contains("opened");
    parent.classList.toggle("opened");
    if (isOpened) {
      answer.style.maxHeight = "0";
    } else {
      answer.style.maxHeight = answer.scrollHeight + 24 + "px";
    }
  }
})();
